/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArchiveCabinetIcon24Solid = forwardRef('ArchiveCabinetIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 2a4 4 0 0 0-4 4v5.25h16V6a4 4 0 0 0-4-4H8Zm1 5a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 12.75H4V18a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4v-5.25ZM10 16a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z" })));
});
